import { createContext, useContext, useRef, useState } from "react";

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [loading, setLoadingState] = useState(false);
  // Counter tracks how many concurrent async operations are in-flight.
  // The overlay only hides when ALL of them have finished (counter reaches 0).
  const counter = useRef(0);

  const setLoading = (value) => {
    if (value) {
      counter.current += 1;
      setLoadingState(true);
    } else {
      counter.current = Math.max(0, counter.current - 1);
      if (counter.current === 0) {
        setLoadingState(false);
      }
    }
  };

  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};

// Custom hook for easy access
export const useLoading = () => useContext(LoadingContext);
